import Vue from 'vue';
import Router from 'vue-router';
import Mnemonic from '../views/Mnemonic.vue';
import DxChain from '../views/DxChain.vue';
import Disease from '../views/Disease.vue';
import Mistakes from '../views/Mistakes.vue';
import Record from '../views/Record.vue';
import PatientSim from '../views/PatientSim.vue';
import Training from '../views/Training.vue';
import Notes from '../views/Notes.vue';
import Plan from '../views/Plan.vue';

Vue.use(Router);

const Auth = () => import('../views/Auth.vue');
const Profile = () => import('../views/Profile.vue');
const History = () => import('../views/History.vue');

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/mnemonic' },
    { path: '/workspace', redirect: '/mnemonic' },
    { path: '/auth', component: Auth, meta: { public: true } },
    { path: '/mnemonic', component: Mnemonic },
    { path: '/patient', component: PatientSim },
    { path: '/dx-chain', component: DxChain },
    { path: '/record', component: Record },
    { path: '/training', component: Training },
    { path: '/mistakes', component: Mistakes },
    { path: '/disease', component: Disease },
    { path: '/history', component: History },
    { path: '/profile', component: Profile },
    { path: '/notes', component: Notes },
    { path: '/plan', component: Plan },
  ],
});
